import { Component } from '@verndale/core';
import { func } from 'prop-types';

class Module extends Component {
  setupDefaults() {
    this.dom = {
      $allItems: this.el._$$('.generic-accordion__item'),
      $allTitles: this.el._$$('.generic-accordion__item-title'),
      $expandAll: this.el._$('.generic-accordion__control--expand'),
      $collapseAll: this.el._$('.generic-accordion__control--collapse'),
      $viewAll: this.el._$('.generic-accordion__view-all')
    };

    this.maxItems =
      this.stringToNumber(this.el.getAttribute('data-max-items')) || 0;
    this.countItems = 0;
    this.activeCount = 0;
    this.allItems = this.maxItems < 1;

    this.itemShowClass = 'generic-accordion__item--show';
    this.viewAllShowClass = 'generic-accordion__view-all--show';
    this.titleActiveClass = 'generic-accordion__item-title--active';
    this.controlShowClass = 'generic-accordion__control--show';

    this.init();
    this.showHideControls();
  } //setupDefaults

  addListeners() {
    const { $allTitles, $expandAll, $collapseAll, $viewAll } = this.dom;

    //$allTitles._on('click', this.scrollTop.bind(this));

    $allTitles._on('click', this.toggledata.bind(this));

    if ($expandAll) {
      $expandAll._on('click', this.expandAll.bind(this));
    }

    if ($collapseAll) {
      $collapseAll._on('click', this.collapseAll.bind(this));
    }

    if ($viewAll) {
      $viewAll._on('click', this.viewAll.bind(this));
    }
  } //addListeners

  stringToNumber(value) {
    try {
      return parseInt(value);
    } catch (error) {
      return 0;
    }
  } //stringToNumber

  init() {
    this.initViewAll();
    this.initShowItems();
    this.scrollTop();
  } //init

  initViewAll() {
    const { $viewAll, $allItems } = this.dom;

    try {
      this.countItems = $allItems.length || 0;

      if (this.countItems > this.maxItems && $viewAll && !this.allItems) {
        $viewAll.classList.add(this.viewAllShowClass);
      }

      this.allItems = this.allItems || this.countItems <= this.maxItems;
    } catch (error) {
      return;
    }
  } //initViewAll

  initShowItems() {
    const { $allItems } = this.dom;

    if (this.allItems) {
      for (const $item of $allItems) {
        $item.classList.add(this.itemShowClass);
      }
    } else {
      for (const [index, $item] of $allItems.entries()) {
        if (index < this.maxItems) {
          $item.classList.add(this.itemShowClass);
        }
      }
    }
  } //initShowItems

  scrollTop() {
    const { $allTitles } = this.dom;
    const elements = document.getElementsByClassName('pdp-anchor-bar__container');

    if (elements.length > 0) {
      $($allTitles).on('click', function(e){
        setTimeout(() => {
          $('body, html').animate({
            scrollTop: $(this).offset().top - 80
          }, 500)
        }, 400);
      })
    } else {
      $($allTitles).on('click', function(e){
        setTimeout(() => {
          $('body, html').animate({
            scrollTop: $(this).offset().top
          }, 500)
        }, 400);
      })
    }
  }//scrollTop

  toggledata(e) {
    e.preventDefault();
    const $title = e.target.closest('.generic-accordion__item-title');
    const $data = $title.nextElementSibling;

    $title.classList.toggle(this.titleActiveClass);

    if ($data.style.maxHeight) {
      this.activeCount--;
      $data.style.maxHeight = null;
    } else {
      this.activeCount++;
      $data.style.maxHeight = `${$data.scrollHeight}px`;
    }

    this.showHideControls();
  } //toggledata

  expandAll(e) {
    e.preventDefault();
    const { $allTitles } = this.dom;

    try {
      this.activeCount = this.allItems ? this.countItems : this.maxItems;

      if (this.allItems) {
        for (const $title of $allTitles) {
          const $data = $title.nextElementSibling;

          $title.classList.add(this.titleActiveClass);
          $data.style.maxHeight = `${$data.scrollHeight}px`;
        }
      } else {
        for (const [index, $title] of $allTitles.entries()) {
          if (index < this.maxItems) {
            const $data = $title.nextElementSibling;

            $title.classList.add(this.titleActiveClass);
            $data.style.maxHeight = `${$data.scrollHeight}px`;
          }
        }
      }
    } catch (error) {
      return;
    }

    this.showHideControls();
  } //expandAll

  collapseAll(e) {
    e.preventDefault();
    const { $allTitles } = this.dom;

    this.activeCount = 0;

    for (const $title of $allTitles) {
      const $data = $title.nextElementSibling;

      $title.classList.remove(this.titleActiveClass);
      $data.style.maxHeight = null;
    }

    this.showHideControls();
  } //collapseAll

  viewAll(e) {
    e.preventDefault();
    const { $allItems, $viewAll } = this.dom;

    $viewAll.classList.remove(this.viewAllShowClass);
    for (const $item of $allItems) {
      $item.classList.add(this.itemShowClass);
    }

    this.allItems = true;

    this.showHideControls();
  } //viewAll

  showHideControls() {
    const { $expandAll, $collapseAll } = this.dom;

    if (this.allItems) {
      if (this.activeCount >= this.countItems) {
        this.hideControl({ element: $expandAll });
      } else {
        this.showControl({ element: $expandAll });
      }
    } else {
      if (this.activeCount >= this.maxItems) {
        this.hideControl({ element: $expandAll });
      } else {
        this.showControl({ element: $expandAll });
      }
    }

    if (this.activeCount >= 1) {
      this.showControl({ element: $collapseAll });
    } else {
      this.hideControl({ element: $collapseAll });
    }
  } //showHideControls

  showControl({ element }) {
    if (element) {
      element.classList.add(this.controlShowClass);
    } else {
      return;
    }
  } //showControl

  hideControl({ element }) {
    if (element) {
      element.classList.remove(this.controlShowClass);
    } else {
      return;
    }
  } //hideControl
}

export default Module;
